import React from "react";
import { Link } from "react-router-dom";
import DataTable from "react-data-table-component";
import { CardHeader } from "react-bootstrap";
import HeaderContent from "../HeaderContent";
import DataTableSearch from "../DataTableSearch";
import guLocale from "../../locales/gu";

const AdminApprovalRequestListing= ({ approvalRequests, columns, handleApprove, 
  handleReject, filterText, handleFilterChange, 
  isFilterVisible, headData, userData,
  handleApplyFilters, headFilterOptions }) => {
    const localeGlobal = guLocale.global;
    const locale = guLocale.admin.approvalRequest;
    const paginationComponentOptions = {
      rowsPerPageText: localeGlobal.rowsPerPageText, // Gujarati text for "Rows per page"
      rangeSeparatorText: localeGlobal.rangeSeparatorText, // Gujarati text for "of"
      selectAllRowsItem: true,
      selectAllRowsItemText: localeGlobal.selectAllRowsItemText, // Gujarati text for "All"
    };
    const translateFields = (record) => {
      return {
        ...record,
        before: {
          "હેડનું નામ": record.before.head_name,
          "વિગતો": record.before.details,
          "રકમ": record.before.amount,
          "તારીખ": record.before.transaction_date,
          "પ્રકાર": record.before.transaction_type,
          "ચુકવણી રીત": record.before.payment_method,
          "ચેક/PFMS નંબર": record.before.cheque_number,
          "ક્લિયરિંગ તારીખ": record.before.clearing_date,
        },
        after: {
          "હેડનું નામ": record.after?.head_name,
          "વિગતો": record.after?.details,
          "રકમ": record.after?.amount,
          "તારીખ": record.after?.transaction_date,
          "પ્રકાર": record.after?.transaction_type,
          "ચુકવણી રીત": record.after?.payment_method,
          "ચેક/PFMS નંબર": record.after?.cheque_number,
          "ક્લિયરિંગ તારીખ": record.after?.clearing_date,
        }
      };
    };
    
    const transformedData = approvalRequests.map(translateFields);
    const ExpandedComponent = ({ data }) => (
        <div style={{ padding: "10px", background: "#f9f9f9", borderRadius: "5px", fontSize: '12px' }}>
            <h5>{locale.descriptions}</h5>
            <table className="table table-bordered">
                <thead>
                    <tr>
                        <th>{locale.description}</th>
                        <th>{locale.before}</th>
                        <th>{locale.after}</th>
                    </tr>
                </thead>
                <tbody>
                    {Object.keys(data.before).map((key) => (
                        <tr key={key}>
                            <td>{key.replace("_", " ").toUpperCase()}</td>
                            <td>{data.before[key] || "-"}</td>
                            <td>{data.after[key] || "-"}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <div>
                <button className="btn btn-primary btn-sm" onClick={() => handleApprove(data._id)}>મંજૂર કરો</button>
                <button className="btn btn-danger btn-sm" style={{ marginLeft: "10px" }} onClick={() => handleReject(data._id)}>નકારો</button>
            </div>
        </div>
    );

    return (
      <div>
        <div className="content-wrapper">
          <div className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-6">
                  <h1 className="m-0">{locale.approvalRequests}</h1>
                </div>
                <div className="col-sm-6">
                  <ol className="breadcrumb float-sm-right">
                    <li className="breadcrumb-item">
                      <Link to="/dashboard">{locale.homeBreadcrumb}</Link>
                    </li>
                    <li className="breadcrumb-item active">{locale.approvalRequests}</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
          <section className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-12">
                  <div className="card">
                    <CardHeader className="card-header">
                      <HeaderContent className="header-content-full-width">
                        <DataTableSearch filterText={filterText} 
                        handleFilterChange={handleFilterChange}  
                        handleApplyFilters={handleApplyFilters}
                        filterOptions={headFilterOptions}
                        isFilterVisible={isFilterVisible}
                        users={userData}
                        heads={headData}
                        />
                      </HeaderContent>
                    </CardHeader>
                    <div className="card-body">
                    <DataTable
                        columns={columns}
                        // data={approvalRequests}
                        data={transformedData}
                        expandableRows
                        noDataComponent={localeGlobal.noRecordsToDisplayLabel}
                        paginationComponentOptions={paginationComponentOptions}
                        expandableRowsComponent={ExpandedComponent}
                        pagination
                        highlightOnHover
                        striped
                    />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    );
};

export default AdminApprovalRequestListing;
